import styled from 'styled-components';
import media from '../../../../styles/media.style';

export const Container = styled.div`
  padding-top: 50px;
  padding-bottom: 0px;
  min-height: 100vh;

  ${media.tabletP`
    padding-top: 120px;
  `};
`;

export const ErrorMessage = styled.div`
  text-align: center;
  color: #f00;
  margin-top: 20px;
`;

export const Container2 = styled.div`
  margin-top: 40px;
`;



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SublimicDiagnosisPage/QuickDiagnosisPage/QuickDiagnosisPage.style.js